import React, {Component} from "react";
import AuthCheck from "../components/AuthCheck";
import {Container} from "react-bootstrap";



import {Step1, Step2, Step3} from "./CaseCreateForms";
export class CaseCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {step: 0,
            values: {
                name: "",
                deadline: "",
                description: "",
                files: { images: '',template: '', gold:''},
                atlas: '',
                allowUpload:false,
                allowView:false,
                allowCompare: false,
                allowDelete: false
            }}
    }

    processData = (step,values) => {
        console.log(step,values)
        this.setState({step: step,values: values});
    }

    getStepComp(step){
        switch (step) {
            case 0:
                return <Step1 data={this.state.values} cb={this.processData}/>
            case 1:
                return <Step2 data={this.state.values} cb={this.processData}/>
            case 2:
                return <Step3 data={this.state.values} cb={this.processData}/>
            default:
                return <Step1 data={this.state.values} cb={this.processData}/>
        }
    }
    // const {setaccountC} = useContext(accountContext);

    render(){
        return(
            <>
                <AuthCheck/>
                <Container>

                    { this.getStepComp(this.state.step)}
                    {/*<Outlet/>*/}

                </Container>



            </>
        )
    }
}

export default CaseCreate;
